// Module
var code = "<main-dashboard></main-dashboard> ";
// Exports
var _module_exports = code;;
var path = '/App/Components/Dashboard/Dashboard.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;